module.exports = __webpack_public_path__ + "static/media/shoe-white.b6868149.svg";